export const getAutoGroupColumnWidthToFit = ({
  currentWidth,
  minWidth,
  totalWidth,
  availableWidth,
}: {
  currentWidth: number;
  minWidth: number;
  totalWidth: number;
  availableWidth: number;
}) => {
  const overflow = totalWidth - availableWidth;
  if (overflow <= 0) {
    return currentWidth;
  }
  return Math.max(Math.min(minWidth, currentWidth), currentWidth - overflow);
};
